









































































































































import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator';
import {
  filter, isFinite, map, reject, sum,
} from 'lodash';
import { Message } from 'element-ui';
import BankAccountsModule from '@/store/bank-accounts';

import PaymentOrderGroup from '@/components/PaymentOrderGroup.vue';
import PaymentOrderHeader from '@/components/PaymentOrderHeader.vue';

import ChooseDebtorModal from '@/components/ChooseDebtorModal.vue';
import CreditorModal from '@/components/TransactionParticipantModal.vue';
import ScanField from '@/components/ScanField.vue';
import TransactionDto from '@/interfaces/transaction.dto';
import Deferred from '@/utils/deferred';
import { formatMoney } from '@/utils/format';
import { BankAccount } from '@/api/payment-orders';
import ChoosePartyModal from '@/components/ChoosePartyModal.vue';
import PartyModal from '@/components/PartyModal.vue';
import { Transaction } from '@/models/Transaction';
import MoneyInput from '@/components/inputs/MoneyInput.vue';
import DirectDebitModule from '@/store/direct-debit';

@Component({
  name: 'DirectDebitPage',
  methods: { formatMoney },
  computed: {
    BankAccount() {
      return BankAccount;
    },
  },
  components: {
    MoneyInput,
    PartyModal,
    ChoosePartyModal,
    ScanField,
    PaymentOrderHeader,
    PaymentOrderGroup,
    ChooseDebtorModal,
    CreditorModal,
  },
})
export default class PaymentOrder extends Vue {
  activeTransaction = '';

  search = '';

  // Variables used for tracking new creditor submit initiated by transaction component
  isCreditorModalOpen = false;

  creditor: Partial<BankAccount> | null = null;

  debtor: Partial<BankAccount> | null = null;

  // Variables used for tracking new debtor submit

  isDebtorModalOpen = false;

  isScanMode = true;

  isScanModeBeforeModalOpen = false;

  transactions: Transaction[] = [];

  get bankAccounts(): BankAccount[] {
    return BankAccountsModule.bankAccounts ?? [];
  }

  @Ref('scanField')
  readonly scanField!: ScanField;

  get initiatingPartyName() {
    return 'Petračić-projekt d.o.o.';
  }

  get numberOfTransactions() {
    return this.transactions.length;
  }

  get controlSum() {
    return this.calculateControlSum(this.transactions);
  }

  get isAnyModalOpen() {
    return this.isDebtorModalOpen || this.isCreditorModalOpen;
  }

  @Watch('isAnyModalOpen')
  async onIsAnyModalOpenChange(newValue: boolean) {
    if (newValue) {
      this.isScanModeBeforeModalOpen = this.isScanMode;
    } else if (this.isScanModeBeforeModalOpen) {
      window.setTimeout(() => {
        this.isScanMode = true;
        this.scanField.focusScanArea();
      }, 1000);
    }
  }

  calculateControlSum(transactions: Transaction[]) {
    return sum(filter(map(transactions, 'amount'), isFinite));
  }

  creditorDeferred: Deferred<BankAccount> | null = null;

  debtorDeferred: Deferred<BankAccount> | null = null;

  onDebtorSelect(debtor: BankAccount) {
    // eslint-disable-next-line no-unused-expressions
    this.debtorDeferred?.resolve(debtor);

    this.closeDebtorModal();
  }

  onCreditorSelect(creditor: BankAccount) {
    // eslint-disable-next-line no-unused-expressions
    this.creditorDeferred?.resolve(creditor);

    this.closeCreditorModal();
  }

  async onElementAdd(transactionId: string) {
    // this.activeGroup = transactionId;
    await this.$nextTick();

    const elRef = this.$refs[transactionId];

    if ('length' in elRef && '$el' in elRef[0]) {
      elRef[0].$el.scrollIntoView(false);
    }
  }

  openCreditorModal() {
    this.isCreditorModalOpen = true;
  }

  closeCreditorModal() {
    this.isCreditorModalOpen = false;
  }

  openDebtorModal() {
    this.isDebtorModalOpen = true;
  }

  closeDebtorModal() {
    this.isDebtorModalOpen = false;
  }

  async chooseDebtor(debtorInitial: Partial<BankAccount> | null = null) {
    this.debtor = debtorInitial;

    this.openDebtorModal();

    this.debtorDeferred = new Deferred<BankAccount>();

    const debtor = await this.debtorDeferred;

    this.debtorDeferred = null;

    return debtor;
  }

  async chooseCreditor(creditorInitial: Partial<BankAccount> | null = null) {
    this.creditor = creditorInitial;

    this.openCreditorModal();

    this.creditorDeferred = new Deferred<BankAccount>();

    const creditor = await this.creditorDeferred;

    this.creditorDeferred = null;

    return creditor;
  }

  async onTransactionScan(transactionDto: TransactionDto | null) {
    if (!transactionDto) {
      Message.error('Skeniranje neuspješno!');

      return;
    }

    const {
      crdtrNm, crdtrIban, amount, info, model, ref, dbtrNm,
    } = transactionDto;

    let debtor = this.bankAccounts.find(({ name }) => name === transactionDto.dbtrNm);

    if (!debtor) {
      debtor = await this.chooseDebtor({ name: dbtrNm, isPayable: false });
    } else if (!debtor.iban || !debtor.directDebitMandate) {
      debtor = await this.chooseDebtor(debtor);
    }
    if (!debtor) {
      Message.error('Platitelj nije odabran');
      return;
    }

    let creditor = this.bankAccounts.find(
      ({ iban }) => iban === crdtrIban,
    );

    if (!creditor) {
      creditor = await this.chooseCreditor(
        {
          name: crdtrNm,
          iban: crdtrIban,
          isPayable: true,
        },
      );
    } else if (!creditor.creditorSchemeId) {
      creditor = await this.chooseCreditor(creditor);
    }

    if (!creditor) {
      Message.error('Primatelj nije odabran');
      return;
    }

    const transaction = Transaction.from(debtor, creditor, amount, {
      model,
      ref,
      description: info,
      isScanned: true,
    });

    this.transactions.push(transaction);

    Message.success('Skeniranje uspješno!');
  }

  deleteTransaction(transactionId: string) {
    this.transactions = reject(this.transactions, ['id', transactionId]);
  }

  async onPaymentOrderGenerate() {
    try {
      await DirectDebitModule.generatePaymentOrder(this.transactions);
    } catch (e) {
      if (e instanceof Error) {
        Message.error(e.message);
      }
    }
  }
}
